import { GelIcon, GelParagraph, GelScreenDetectorContext } from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import { useContext, useState } from "react";
import {
    StyledFooterContainer,
    StyledHeaderContainer,
    StyledIconContainer,
    StyledPlusIcon,
    StyledProductContainer,
    StyledTitle,
    StyledTitleContainer,
} from "./StyledProductCard";

const ProductCard = ({ color, title, icon, iconColor, description, backgroundColor, onClick }) => {
    const [hover, isHover] = useState(false);
    const { isSmScreen, isMdScreen, screen } = useContext(GelScreenDetectorContext);

    return (
        <StyledProductContainer
            color={color}
            backgroundColor={backgroundColor}
            onMouseEnter={() => isHover(true)}
            onMouseLeave={() => isHover(false)}
            onClick={onClick}
        >
            <StyledHeaderContainer minHeight={isSmScreen(screen) ? 220 : isMdScreen(screen) ? 180 : 150}>
                <StyledTitleContainer>
                    <StyledTitle>{title}</StyledTitle>
                </StyledTitleContainer>
                <GelParagraph
                    style={{
                        color: hover
                            ? getGelTokens().global.themeColorTextDark
                            : getGelTokens().global.themeColorTextLight,
                    }}
                    marginBottom={16}
                >
                    {description}
                </GelParagraph>
            </StyledHeaderContainer>

            <StyledFooterContainer>
                <StyledPlusIcon hover={hover}>
                    <GelIcon name={icon} width={getGelTokens().global.sizeBaseX5} />
                </StyledPlusIcon>
            </StyledFooterContainer>
        </StyledProductContainer>
    );
};

export { ProductCard };